var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex full"},[_c('div',{staticClass:"d-flex center"},[_c('img',{attrs:{"src":require("../../assets/logo.png")}}),_c('div',{staticClass:"mt-5"},[_c('div',{staticClass:"desc text-center"},[_vm._v(_vm._s(_vm.des))]),_c('div',{staticClass:"text-danger text-center message"},[_vm._v(_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }